import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";

const crudApi = createApi({
    reducerPath: 'crudApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllCRUDCategoryList: builder.query({
            query: (details) => ({
                url: "/CRUD/GetAllCRUDCategoryList",
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addCRUDCategory: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/AddCRUDCategory`),
                method: 'POST',
                body: transformRequest(details, "create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        editCRUDCategory: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/EditCRUDCategory`),
                method: 'POST',
                body: transformRequest(details, "update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCRUDCategoryById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/DeleteCRUDCategoryById?id=${parseInt(id)}`),
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteRequirementAdditionalFieldById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/DeleteRequirementAdditionalFieldById?id=${parseInt(id)}`),
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropdownForCRUDCategory: builder.query({
            query: () => ({
                url: encryptQueryString('/CRUD/GetAllDropdownForCRUDCategory'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllRequirmentList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllRequirmentList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllRequirmentListForApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllRequirmentListForApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCriteriaList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllCriteriaList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitRequirmentInformation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/SubmitRequirmentInformation`),
                method: 'POST',
                body: transformRequest(details, "create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        editRequirmentInformation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/EditRequirmentInformation`),
                method: 'POST',
                body: transformRequest(details, "update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditRequirementAdditionalField: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/AddEditRequirementAdditionalField`),
                method: 'POST',
                body: transformRequest(details, "update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllRequirementListForSectionA: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllRequirementListForSectionA`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllRequirementListForSectionB: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllRequirementListForSectionB`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllRequirementListForSectionC: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllRequirementListForSectionC`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitCriteriaInFormation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/SubmitCriteriaInFormation`),
                method: 'POST',
                body: transformRequest(details, "create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPRequirementDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/GetSGBPRequirementDetailsById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSGBPCriteriaDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/GetSGBPCriteriaDetailsById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCategoryCriteriaCertificateMappingById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/GetCategoryCriteriaCertificateMappingById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCriteriaDetails: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/UpdateCriteriaDetails`),
                method: 'POST',
                body: transformRequest(details, "update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCategoryCriteriaMappingList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllCategoryCriteriaMappingList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitCategoryCriteriaCertificateMappingInformation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/SubmitCategoryCriteriaCertificateMappingInformation`),
                method: 'POST',
                body: transformRequest(details,"create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCategoryCriteriaCertificateMappingInformation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/UpdateCategoryCriteriaCertificateMappingInformation`),
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveSGBPRequirementById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/ApproveSGBPRequirementById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCategoryCriteriaMappingListForApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllCategoryCriteriaMappingListForApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveSGBPCategoryCriteriaCertificateMappingById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/ApproveSGBPCategoryCriteriaCertificateMappingById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllCriteriaListForApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/GetAllCriteriaListForApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveSGBPCriteriaById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CRUD/ApproveSGBPCriteriaById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
         getAllDropdownForSubCategoryByL1: builder.mutation({
            query: (details) => ({
                url: '/CRUD/GetAllDropdownForSubCategoryByL1',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropdownForTypeByL2: builder.mutation({
            query: (details) => ({
                url: '/CRUD/GetAllDropdownForTypeByL2',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getL1DropdownByChannelId: builder.mutation({
            query: (details) => ({
                url: '/CRUD/GetL1DropdownByChannelId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        dDownloadProductCertificationAssessmentCritreria: builder.mutation({
            query: (details) => ({
                url: (`/ProductsAndServices/DownloadProductCertificationAssessmentCritreria`),
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
    })
})

export const {
    useLazyGetAllCRUDCategoryListQuery,
    useAddCRUDCategoryMutation,
    useEditCRUDCategoryMutation,
    useLazyDeleteCRUDCategoryByIdQuery,
    useLazyGetAllDropdownForCRUDCategoryQuery,
    useGetAllRequirmentListMutation,
    useSubmitRequirmentInformationMutation,
    useLazyGetSGBPRequirementDetailsByIdQuery,
    useEditRequirmentInformationMutation,
    useAddEditRequirementAdditionalFieldMutation,
    useLazyDeleteRequirementAdditionalFieldByIdQuery,
    useGetAllCriteriaListMutation,
    useGetAllRequirementListForSectionAMutation,
    useGetAllRequirementListForSectionBMutation,
    useGetAllRequirementListForSectionCMutation,
    useSubmitCriteriaInFormationMutation,
    useLazyGetSGBPCriteriaDetailsByIdQuery,
    useUpdateCriteriaDetailsMutation,
    useGetAllCategoryCriteriaMappingListMutation,
    useSubmitCategoryCriteriaCertificateMappingInformationMutation,
    useLazyGetCategoryCriteriaCertificateMappingByIdQuery,
    useUpdateCategoryCriteriaCertificateMappingInformationMutation,
    useGetAllRequirmentListForApprovalMutation,
    useApproveSGBPRequirementByIdMutation,
    useGetAllCategoryCriteriaMappingListForApprovalMutation,
    useApproveSGBPCategoryCriteriaCertificateMappingByIdMutation,
    useGetAllCriteriaListForApprovalMutation,
    useApproveSGBPCriteriaByIdMutation,
    useGetAllDropdownForSubCategoryByL1Mutation,
    useGetAllDropdownForTypeByL2Mutation,
    useGetL1DropdownByChannelIdMutation,
    useDDownloadProductCertificationAssessmentCritreriaMutation
} = crudApi;

export default crudApi;